import { useMemo } from 'react';

import { ISalaryInfo } from '~types/company';
import { getRankingGroup, getSalaryType, RankingGroupText } from '~utils/company/company';

import { S } from '../style';

interface Props {
  salary: ISalaryInfo;
}

function SalarySummary({ salary }: Props) {
  const salaryType = useMemo(() => getSalaryType(salary), [salary]);

  const rankingGroup = getRankingGroup(salaryType.salaryRate);

  if (!getRankingGroup(salaryType.salaryRate) || !salary.salary || !rankingGroup) {
    return null;
  }

  const text = `연봉 규모가 ${salary.rateType === 'INDUSTRY' ? '동종업계' : '전체'}에서 <span>${
    RankingGroupText[rankingGroup]
  }</span>인 기업이에요`;

  return <S.Summary dangerouslySetInnerHTML={{ __html: text }} />;
}

export default SalarySummary;
